"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionalLabourRates = void 0;
const assimoco_1 = require("./assimoco");
const conte_1 = require("./conte");
const realemutua_1 = require("./realemutua");
const sara_1 = require("./sara");
function getRegionalLabourRates(client) {
    switch (client) {
        case 'conte':
            return conte_1.CONTE;
        case 'sara':
            return sara_1.SARA;
        case 'realemutua':
            return realemutua_1.REALE_MUTUA;
        case 'assimoco':
            return assimoco_1.ASSIMOCO;
        default:
            return null;
    }
}
exports.getRegionalLabourRates = getRegionalLabourRates;
//# sourceMappingURL=getRegionalLabourRates.js.map